// 全局配置项
export const PRIMARY_COLOR = '#3366FF'
export const PRIMARY_COLOR_ACTIVE = '#3366FF'
export const PRIMARY_COLOR_HOVER = '#3366FF'